export default __webpack_public_path__ + "fonts/Roboto-400-latin-ext13.woff2";